'use client'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { useTranslations } from 'next-intl'
import { useState } from 'react'

export default function useConfirm() {
  const tBtns = useTranslations('btns')
  const tConfirmation = useTranslations('errors.confirmation')
  const [confirmState, setConfirmState] = useState({
    isOpen: false,
    title: tConfirmation('title'),
    message: tConfirmation('message'),
    resolve: null,
  })
  const [texts, setTexts] = useState({
    cancelText: tBtns('cancel'),
    confirmText: tBtns('confirm'),
  })

  const confirm = (
    message,
    title,
    options = { cancelText: '', confirmText: '' }
  ) => {
    return new Promise((resolve) => {
      if (options.cancelText || options.confirmText) {
        setTexts((pre) => {
          const newValue = { ...pre }
          if (options.cancelText) newValue.cancelText = options.cancelText
          if (options.confirmText) newValue.confirmText = options.confirmText
          return newValue
        })
      }
      setConfirmState({
        isOpen: true,
        message: message ?? confirmState.message,
        title: title ?? confirmState.title,
        resolve,
      })
    })
  }

  const ConfirmComponent = () => (
    <Dialog
      open={confirmState.isOpen}
      onClose={() => {
        confirmState.resolve(false)
        setConfirmState((prev) => ({ ...prev, isOpen: false }))
      }}
    >
      <DialogTitle>{confirmState.title}</DialogTitle>
      <DialogContent>
        <DialogContentText component={'div'}>
          {confirmState.message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            confirmState.resolve(false)
            setConfirmState((prev) => ({ ...prev, isOpen: false }))
          }}
          variant='outlined'
          color='error'
        >
          {texts.cancelText}
        </Button>
        {texts.confirmText && (
          <Button
            onClick={() => {
              confirmState.resolve(true)
              setConfirmState((prev) => ({ ...prev, isOpen: false }))
            }}
            variant='contained'
            color='primary'
            autoFocus
          >
            {texts.confirmText}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )

  return { confirm, ConfirmComponent }
}
